import Vue from "vue"
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import VBodyScrollLock from 'v-body-scroll-lock'
import VuePortal from '@linusborg/vue-simple-portal'
import App from "@/components/App.vue"
import NavigationAuth from "@/components/NavigationAuth.vue"
import AircraftList from "@/components/aircraft/AircraftList.vue"
import ContactForm from "@/components/contact/ContactForm.vue"
import FlytRanges from "@/components/ranges/FlytRanges.vue"
import ApiService from '@/services/apiService'
import TokenService from '@/services/storageService'
import { mapActions, mapGetters, mapMutations } from "vuex";

// Global app` css
import "@/assets/scss/global.scss"

const locationType = {
	helipad: "helicopter",
	airport: "aeroplane",
}

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_API_URL)

// If token exists set header
if (TokenService.getToken()) ApiService.setHeader()

// Add Vue plugins
Vue.use(Vuelidate)
Vue.use(VBodyScrollLock)
Vue.use(VuePortal, { name: 'portal' })
Vue.use(
	VueGoogleMaps,
	{
		load: {
			key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
			libraries: ['geometry', 'places']
		}
	}
)

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
            el.setAttribute('data-dragging', 'yes')
        }
        el.eventClearDrag = function () {
            el.removeAttribute('data-dragging')
        }
        el.eventOnClick = function (event) {
            var dragging = el.getAttribute('data-dragging')
            // Check that the click was outside the el and its children, and wasn't a drag
            if (!(el == event.target || el.contains(event.target)) && !dragging) {
                // call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.addEventListener('touchstart', el.eventClearDrag)
        document.addEventListener('touchmove', el.eventSetDrag)
        document.addEventListener('click', el.eventOnClick)
        document.addEventListener('touchend', el.eventOnClick)
    },
	unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag)
        document.removeEventListener('touchmove', el.eventSetDrag)
        document.removeEventListener('click', el.eventOnClick)
        document.removeEventListener('touchend', el.eventOnClick)
        el.removeAttribute('data-dragging')
    },
});

// Homepage booking-app 
let bookingApp = document.getElementById("booking-app")
if (bookingApp) {
	let dataLocationApiID = +bookingApp.getAttribute("data-location-location-api-id");
		
	new Vue({
		render: h => h(App),
		store,
		methods: {
			...mapActions("bookingForm", ["storeLocationValue", "storeDefaultDestinationLocation", "storeAircraftCategory"]),
			...mapMutations("bookingForm", ["setAircraftCategory"]),
			...mapMutations("map", ["setJourneyMarker"]),
			...mapGetters("map", ["markers"]),
		},
		mounted() {
			if (dataLocationApiID !== null && dataLocationApiID !== 0) {
				setTimeout(() => {
					let resource = `locations/${dataLocationApiID}`;
					let config = {
						// cancelToken: new ApiService.CancelToken(function executor(c) { cancel = c })
					}
					// isLoading(true)
					ApiService.get(resource, config)
						.then(response => {
							const location = response.data.data;
							setTimeout(() => {
								const formattedLocation = {
									distance: 0,
									id: dataLocationApiID,
									isGeoArea: false,
									lat: location.lat,
									lng: location.lng,
									locationType: "destination",
									primary: location.name,
									secondary: location.display_name
								}
								this.setJourneyMarker({
									newMarker: formattedLocation,
									locationType: 'destination'
								});
								this.storeDefaultDestinationLocation(true);
								this.storeLocationValue({
									value: formattedLocation,
									locationType: 'destination',
								});
								this.storeAircraftCategory(locationType[location.type.slug]);
							});
						})
						// .catch(() => this.onSearchUnsuccessful())
						// .then(() => isLoading(false));
				});
			}
		},

	}).$mount("#booking-app")
}

// Main navigation user section
let navbarAuth = document.querySelector("#navbar__auth")
if (navbarAuth) {
	new Vue({
		render: h => h(NavigationAuth),
		store
	}).$mount("#navbar__auth")
}

// Helicopters archive list
let helicoptersList = document.querySelector("#helicopter-list")
if (helicoptersList) {
	new Vue({
		render: h => h(AircraftList),
		store
	}).$mount("#helicopter-list")
}

// Contact page form
let contactForm = document.querySelector('#contact-form')
if (contactForm) {
	new Vue({
		// Custom render method appends props, passed
		// as data attributes on the target element
		render: createElement => {
			const context = {
				props: { ...contactForm.dataset },
			};
			console.log(context)
			return createElement(ContactForm, context);
		}
	}).$mount("#contact-form")
}

// Ranges map
let rangeMap = document.querySelector('#range-map')
if (rangeMap) {
	new Vue({
		render: h => h(FlytRanges)
	}).$mount("#range-map")
}
